import React from "react";

export const FormulationTable = ({ ingredients = [], basisLabel = "per tablet", compact = false, testId }) => (
    <div className="overflow-x-auto" data-testid={testId}>
        <table className="w-full text-sm">
            <thead>
                <tr className="text-left border-b border-white/10">
                    <th className="mono text-[10px] tracking-[0.18em] text-zinc-500 font-normal py-3 pr-4">Ingredient</th>
                    <th className="mono text-[10px] tracking-[0.18em] text-zinc-500 font-normal py-3 text-right whitespace-nowrap">
                        {basisLabel}
                    </th>
                    {!compact && (
                        <th className="mono text-[10px] tracking-[0.18em] text-zinc-500 font-normal py-3 pl-4 hidden sm:table-cell">
                            Botanical / scientific name
                        </th>
                    )}
                </tr>
            </thead>
            <tbody className="divide-y divide-white/5">
                {ingredients.map((ing) => (
                    <tr key={ing.id || ing.name}>
                        <td className="py-3 pr-4">
                            <span className="text-white">{ing.name}</span>
                            {compact && ing.botanical_name && (
                                <span className="block text-[11px] italic text-zinc-500">{ing.botanical_name}</span>
                            )}
                        </td>
                        <td className="py-3 text-gold text-right whitespace-nowrap">{ing.quantity} {ing.unit}</td>
                        {!compact && (
                            <td className="py-3 pl-4 text-zinc-500 italic hidden sm:table-cell">{ing.botanical_name || "—"}</td>
                        )}
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
);

export default FormulationTable;
